<section class="deliveredVehicle">
  <h5 class="deliveredVehicle--title">
    {{ 'deliveredVehicleData' | i18next }}
  </h5>
  <div
    class="deliveredVehicle--replacedData"
    *ngIf="!vehicleRegistrationData && !deliveredVehicle"
  >
    <p>{{ 'noDataAvailable' | i18next }}</p>
  </div>
  <div>
    <div
      class="deliveredVehicle--replacedData"
      *ngIf="vehicleRegistrationData || deliveredVehicle"
    >
      <div
        class="deliveredVehicle--replacedData__row"
        *ngIf="vehicleRegistrationData"
      >
        <p class="label">{{ 'plateNumber' | i18next }}</p>
        <p class="text">
          {{
            vehicleRegistrationData.plateNumber
              ? vehicleRegistrationData.plateNumber
              : emptyData
          }}
        </p>
      </div>
      <div
        class="deliveredVehicle--replacedData__row"
        *ngIf="vehicleRegistrationData"
      >
        <p class="label">{{ 'summaryVinNumberDate' | i18next }}</p>
        <p class="text">
          {{
            vehicleRegistrationData.plateNumberDate
              ? vehicleRegistrationData.plateNumberDate
              : emptyData
          }}
        </p>
      </div>
      <div
        class="deliveredVehicle--replacedData__row"
        *ngIf="vehicleRegistrationData"
      >
        <p class="label">{{ 'summaryInsuranceType' | i18next }}</p>
        <p class="text">
          {{
            vehicleRegistrationData.insuranceType
              ? vehicleRegistrationData.insuranceType
              : emptyData
          }}
        </p>
      </div>
      <div class="deliveredVehicle--replacedData__row" *ngIf="deliveredVehicle">
        <p class="label">
          {{ 'model' | i18next }}
        </p>
        <p class="text">
          {{ deliveredVehicle.model ? deliveredVehicle.model : emptyData }}
        </p>
      </div>

      <div class="deliveredVehicle--replacedData__row" *ngIf="deliveredVehicle">
        <p class="label">
          {{ 'color' | i18next }}
        </p>
        <p class="text">
          {{
            deliveredVehicle.exteriorColor
              ? deliveredVehicle.exteriorColor.description
              : emptyData
          }}
        </p>
      </div>
      <div class="deliveredVehicle--replacedData__row" *ngIf="deliveredVehicle">
        <p class="label">
          {{ 'combustible' | i18next }}
        </p>
        <p class="text">
          {{
            deliveredVehicle.fuelType ? deliveredVehicle.fuelType : emptyData
          }}
        </p>
      </div>
      <div
        class="deliveredVehicle--replacedData__row"
        *ngIf="vehicleRegistrationData"
      >
        <p class="label">{{ 'deliveryDate' | i18next }}</p>
        <p class="text">
          {{
            vehicleRegistrationData
              ? vehicleRegistrationData.deliveryDate
                ? vehicleRegistrationData.deliveryDate
                : emptyData
              : emptyData
          }}
        </p>
      </div>
      <div class="deliveredVehicle--replacedData__row" *ngIf="deliveredVehicle">
        <p class="label">{{ 'productionWeek' | i18next }}</p>
        <p class="text">
          {{
            deliveredVehicle
              ? deliveredVehicle.productionWeek
                ? deliveredVehicle.productionWeek
                : emptyData
              : emptyData
          }}
        </p>
      </div>
      <div class="deliveredVehicle--replacedData__row" *ngIf="deliveredVehicle">
        <p class="label">
          {{ 'optionals' | i18next }}
        </p>
        <p class="text">{{ getFormattedDescriptions() }}</p>
      </div>
    </div>
    <div *ngIf="appraisalValue" class="appraisalValue">
      <p class="appraisalValue--label">{{ 'appraisalValue' | i18next }}</p>
      <p class="appraisalValue--info">{{ appraisalValue }}</p>
    </div>
  </div>
</section>
